import { connect } from 'react-redux';

import { getIsHotelOnly, searchTypeSelector } from 'src/store/view/selectors';
import { hasResults } from '../../../searchStatus/selectors';
import { getIsSubscribeShown, isFiltersHidden } from '../../../selectors/view';
import { isEmptyFiltrationSelector } from '../../../store/emptyFiltration/selectors';
import { hotelsCountSelector } from '../../../store/hotels/selectors';
import SearchPageMobile from './SearchPageMobile';

const mapStateToProps = (state) => ({
  isHotelOnly: getIsHotelOnly(state),
  hideFilters: isFiltersHidden(state),
  isSubscribeShown: getIsSubscribeShown(state),
  isEmptyFiltration: isEmptyFiltrationSelector(state),
  hasSearchResults: hasResults(state),
  searchType: searchTypeSelector(state),
  hotelsCount: hotelsCountSelector(state),
});

export default connect(mapStateToProps)(SearchPageMobile);
